import script from "./SafeWord.vue?vue&type=script&setup=true&lang=ts"
export * from "./SafeWord.vue?vue&type=script&setup=true&lang=ts"

import "./SafeWord.vue?vue&type=style&index=0&id=21fb24ac&scoped=true&lang=less"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21fb24ac"]])

export default __exports__